import { getSeedingMeRecruitmentCount as getSeedingMeRecruitmentCountApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetSeedingMeRecruitmentCountServiceResponse } from './get-seeding-me-recruitment-count.dto';
import { GetSeedingMeRecruitmentCountServiceResponseSchema } from './get-seeding-me-recruitment-count.dto';

export const getSeedingMeRecruitmentCountService = withServiceErrorCapture(
  lazyPipe(async (): Promise<GetSeedingMeRecruitmentCountServiceResponse> => {
    const apiResponse = await getSeedingMeRecruitmentCountApi();

    if (apiResponse.meta?.result === 'FAIL') {
      throw new Error(apiResponse.meta?.message ?? '신청 카운트 조회에 실패했습니다.');
    }
    return apiResponse.data;
  }, validateServiceResponse(GetSeedingMeRecruitmentCountServiceResponseSchema)),
);
